<template>
    <Content>
        <Modal modal_id="modal_carousel_images">
            <template v-for="(image, key) in images">
                <figure :key="key">
                    <img :src="image.image" :alt="image.alt">
                </figure>
            </template>
        </Modal>
    </Content>
</template>

<script>
import { mapState } from 'vuex';
import Modal from "../Modal";
import { CSecondaryTitle } from "../Styles/Components/styled";
import { Content } from "./style";

export default {
    name: "ModalCarousel",
    components: {
        Modal,
        Content,
        "secondary-title": CSecondaryTitle
    },
    computed: {
        ...mapState("modalCarousel", ["images"])
    }
};
</script>
